import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

// ─── Constants ────────────────────────────────────────────────────────────────
const STATUS_MAP = {
  pending:    { label: 'Bekliyor',     color: '#f59e0b', bg: '#fffbeb' },
  confirmed:  { label: 'Onaylandı',   color: '#6366f1', bg: '#eef2ff' },
  on_the_way: { label: 'Yolda',       color: '#3b82f6', bg: '#eff6ff' },
  measuring:  { label: 'Ölçüm Alınıyor', color: '#ec4899', bg: '#fdf2f8' },
  completed:  { label: 'Tamamlandı',  color: '#10b981', bg: '#ecfdf5' },
  cancelled:  { label: 'İptal',       color: '#ef4444', bg: '#fff5f5' },
  no_access:  { label: 'Kapı Yok',    color: '#94a3b8', bg: '#f1f5f9' },
};
const CITIES = ['Adana','Ankara','Antalya','Bursa','Eskişehir','Gaziantep','İstanbul','İzmir','Kayseri','Konya','Mersin','Samsun','Trabzon','Diğer'];

// ─── Helpers ─────────────────────────────────────────────────────────────────
const api = (path, opts = {}) =>
  axios({ url: `/api${path}`, headers: { Authorization: `Bearer ${localStorage.getItem('crm_token')}` }, ...opts });
const fmt = d => d ? new Date(d).toLocaleString('tr-TR', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' }) : '-';
const fmtD = d => d ? new Date(d).toLocaleDateString('tr-TR') : '-';

// ─── New Survey Modal ─────────────────────────────────────────────────────────
function NewSurveyModal({ onClose, onCreated }) {
  const [form, setForm] = useState({
    first_name: '', last_name: '', phone: '', city: '', district: '', address: '',
    scheduled_at: '', notes: '', internal_notes: '',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const submit = async () => {
    if (!form.first_name || !form.phone) return setError('Ad ve telefon zorunludur.');
    if (!form.scheduled_at) return setError('Randevu tarihi ve saati zorunludur.');
    setSaving(true); setError('');
    try {
      await api('/surveys/direct', { method: 'post', data: form });
      onCreated();
      onClose();
    } catch (e) {
      setError(e.response?.data?.error || 'Kayıt hatası');
    } finally { setSaving(false); }
  };

  return (
    <div style={overlay} onClick={onClose}>
      <div style={{ ...mBox, width: '620px', maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
          <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 800, color: '#0f172a' }}>🔍 Yeni Keşif Randevusu</h2>
          <button onClick={onClose} style={xBtn}>×</button>
        </div>
        {error && <div style={errBox}>{error}</div>}

        <Sec title="👤 Müşteri Bilgileri">
          <div style={g2}>
            <F l="Ad *"><input style={inp} value={form.first_name} onChange={e => set('first_name', e.target.value)} placeholder="Ad" /></F>
            <F l="Soyad"><input style={inp} value={form.last_name} onChange={e => set('last_name', e.target.value)} placeholder="Soyad" /></F>
            <F l="Telefon *"><input style={inp} value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="05xx xxx xx xx" /></F>
            <F l="Şehir">
              <select style={inp} value={form.city} onChange={e => set('city', e.target.value)}>
                <option value="">Seçin</option>
                {CITIES.map(c => <option key={c}>{c}</option>)}
              </select>
            </F>
          </div>
          <F l="İlçe"><input style={inp} value={form.district} onChange={e => set('district', e.target.value)} placeholder="İlçe" /></F>
          <div style={{ marginTop: '10px' }}>
            <F l="Adres"><textarea style={{ ...inp, resize: 'vertical' }} rows={2} value={form.address} onChange={e => set('address', e.target.value)} placeholder="Keşif yapılacak tam adres" /></F>
          </div>
        </Sec>

        <Sec title="📅 Randevu">
          <F l="Randevu Tarihi ve Saati *">
            <input style={inp} type="datetime-local" value={form.scheduled_at} onChange={e => set('scheduled_at', e.target.value)} />
          </F>
        </Sec>

        <Sec title="📝 Notlar">
          <div style={g2}>
            <F l="Müşteri Notu"><textarea style={{ ...inp, resize: 'vertical' }} rows={3} value={form.notes} onChange={e => set('notes', e.target.value)} placeholder="Müşteriye özel not..." /></F>
            <F l="İç Not (Ekip İçin)"><textarea style={{ ...inp, resize: 'vertical' }} rows={3} value={form.internal_notes} onChange={e => set('internal_notes', e.target.value)} placeholder="Ekibe özel talimatlar..." /></F>
          </div>
        </Sec>

        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={btnSec}>İptal</button>
          <button onClick={submit} disabled={saving} style={{ ...btnPri, opacity: saving ? .7 : 1 }}>
            {saving ? 'Kaydediliyor…' : '✅ Randevu Oluştur'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Detail Modal ─────────────────────────────────────────────────────────────
function DetailModal({ survey, onClose, onUpdated, onDeleted }) {
  const [status, setStatus] = useState(survey.status || 'pending');
  const [note, setNote] = useState(survey.internal_notes || '');
  const [saving, setSaving] = useState(false);
  const [confirmDel, setConfirmDel] = useState(false);
  const s = STATUS_MAP[status] || STATUS_MAP.pending;

  const updateStatus = async (newStatus) => {
    setSaving(true);
    try {
      await api(`/surveys/${survey.id}`, { method: 'put', data: { status: newStatus } });
      setStatus(newStatus);
      onUpdated(survey.id, { status: newStatus });
    } catch { alert('Güncellenemedi'); }
    setSaving(false);
  };

  const saveNote = async () => {
    setSaving(true);
    try {
      await api(`/surveys/${survey.id}`, { method: 'put', data: { internal_notes: note } });
      onUpdated(survey.id, { internal_notes: note });
    } catch { alert('Kaydedilemedi'); }
    setSaving(false);
  };

  const doDelete = async () => {
    try {
      await api(`/surveys/${survey.id}`, { method: 'delete' });
      onDeleted(survey.id);
      onClose();
    } catch { alert('Silinemedi'); }
  };

  return (
    <div style={overlay} onClick={onClose}>
      <div style={{ ...mBox, width: '560px', maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' }}>
          <div>
            <div style={{ fontSize: '11px', color: '#94a3b8', marginBottom: '4px' }}>KEŞİF #{survey.id}</div>
            <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 800, color: '#0f172a' }}>
              {survey.customer_first_name} {survey.customer_last_name}
            </h2>
          </div>
          <button onClick={onClose} style={xBtn}>×</button>
        </div>

        {/* Status selector */}
        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '20px' }}>
          {Object.entries(STATUS_MAP).map(([k, v]) => (
            <button key={k} onClick={() => updateStatus(k)} disabled={saving}
              style={{ padding: '6px 12px', border: `2px solid ${status === k ? v.color : '#e2e8f0'}`,
                borderRadius: '20px', background: status === k ? v.bg : 'white',
                color: status === k ? v.color : '#94a3b8', fontWeight: 700, fontSize: '11px', cursor: 'pointer' }}>
              {v.label}
            </button>
          ))}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '20px' }}>
          {[
            ['📞 Telefon', survey.customer_phone || '-'],
            ['📍 Şehir / İlçe', [survey.city, survey.district].filter(Boolean).join(' / ') || '-'],
            ['📅 Randevu', fmt(survey.scheduled_at)],
            ['✅ Tamamlandı', fmtD(survey.actual_date)],
          ].map(([l, v]) => (
            <div key={l} style={{ background: '#f8fafc', padding: '10px 14px', borderRadius: '10px' }}>
              <div style={{ fontSize: '11px', color: '#94a3b8' }}>{l}</div>
              <div style={{ fontSize: '13px', fontWeight: 600, color: '#1e293b', marginTop: '2px' }}>{v}</div>
            </div>
          ))}
        </div>

        {survey.address && (
          <div style={{ background: '#f8fafc', padding: '12px 14px', borderRadius: '10px', marginBottom: '16px', fontSize: '13px', color: '#475569' }}>
            🏠 {survey.address}
          </div>
        )}

        {survey.notes && (
          <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: '10px', padding: '12px', marginBottom: '16px' }}>
            <div style={{ fontSize: '11px', fontWeight: 700, color: '#92400e', marginBottom: '4px' }}>MÜŞTERİ NOTU</div>
            <div style={{ fontSize: '13px', color: '#78350f' }}>{survey.notes}</div>
          </div>
        )}

        <div style={{ marginBottom: '20px' }}>
          <label style={{ fontSize: '12px', fontWeight: 600, color: '#64748b', display: 'block', marginBottom: '6px' }}>📝 İç Not (Ekip İçin)</label>
          <textarea value={note} onChange={e => setNote(e.target.value)} rows={3}
            style={{ width: '100%', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '10px', fontSize: '13px', resize: 'vertical', fontFamily: 'inherit', boxSizing: 'border-box' }} />
          <button onClick={saveNote} disabled={saving}
            style={{ ...btnPri, marginTop: '8px', fontSize: '13px', padding: '8px 18px', opacity: saving ? .7 : 1 }}>
            Kaydet
          </button>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <button onClick={() => setConfirmDel(true)} style={{ padding: '8px 16px', border: '1px solid #fecaca', background: 'white', color: '#ef4444', borderRadius: '8px', cursor: 'pointer', fontWeight: 600, fontSize: '12px' }}>
            🗑 Sil
          </button>
          {status === 'completed' && (
            <span style={{ fontSize: '12px', color: '#10b981', fontWeight: 600 }}>✅ Teklif hazırlayabilirsiniz</span>
          )}
        </div>

        {confirmDel && (
          <div style={{ marginTop: '14px', background: '#fff5f5', padding: '14px', borderRadius: '10px', border: '1px solid #fecaca' }}>
            <p style={{ margin: '0 0 12px', fontSize: '13px', color: '#7f1d1d' }}>Bu keşif randevusunu silmek istediğinize emin misiniz?</p>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button onClick={() => setConfirmDel(false)} style={btnSec}>İptal</button>
              <button onClick={doDelete} style={{ ...btnPri, background: '#ef4444' }}>Evet, Sil</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ─── Route Modal ("Rota Çıkar") ────────────────────────────────────────────────
// Google Maps'in key GEREKTİRMEYEN /maps/dir/ formatı en fazla 11 nokta (origin+9
// waypoint+destination) destekliyor - manuel sıra düzeltmesi sonrası URL'i sunucuya
// tekrar sormadan burada yeniden kurmak için server/routes/surveys.js'teki AYNI
// mantık küçük ölçekte tekrarlanıyor (mesafe hesabı YOK, sadece URL birleştirme).
const MAX_POINTS_PER_MAPS_URL = 11;
function buildMapsUrlsClient(orderedPoints) {
  const chunks = [];
  for (let i = 0; i < orderedPoints.length - 1; i += MAX_POINTS_PER_MAPS_URL - 1) {
    chunks.push(orderedPoints.slice(i, i + MAX_POINTS_PER_MAPS_URL));
  }
  return chunks.map((chunk, idx) => {
    const origin = chunk[0];
    const destination = chunk[chunk.length - 1];
    const waypoints = chunk.slice(1, -1);
    const params = new URLSearchParams({ api: '1', origin: `${origin.lat.toFixed(6)},${origin.lng.toFixed(6)}`, destination: `${destination.lat.toFixed(6)},${destination.lng.toFixed(6)}`, travelmode: 'driving' });
    let url = `https://www.google.com/maps/dir/?${params.toString()}`;
    if (waypoints.length) url += `&waypoints=${waypoints.map(w => `${w.lat.toFixed(6)},${w.lng.toFixed(6)}`).join('%7C')}`;
    return { label: chunks.length > 1 ? `${idx + 1}. Bölüm` : 'Tüm Rota', url };
  });
}
const localDateStr = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

function RouteModal({ surveys, onClose }) {
  const [phase, setPhase] = useState('select'); // 'select' | 'loading' | 'result'
  const [date, setDate] = useState(localDateStr(new Date()));
  const [selectedIds, setSelectedIds] = useState(() => new Set());
  const [startAddress, setStartAddress] = useState('');
  const [startCoords, setStartCoords] = useState(null); // {lat,lng} - "Konumumu Kullan" ile dolar
  const [locating, setLocating] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);
  const [reordered, setReordered] = useState(false);

  const dayCandidates = surveys.filter(s =>
    s.scheduled_at && new Date(s.scheduled_at).toDateString() === new Date(date).toDateString()
    && s.status !== 'completed' && s.status !== 'cancelled'
  ).sort((a, b) => new Date(a.scheduled_at) - new Date(b.scheduled_at));

  useEffect(() => {
    // Tarih değişince, adresi olan tüm adayları varsayılan seçili yap.
    setSelectedIds(new Set(dayCandidates.filter(s => s.address && s.address.trim()).map(s => s.id)));
  }, [date]);

  const toggle = (id) => setSelectedIds(prev => {
    const next = new Set(prev);
    next.has(id) ? next.delete(id) : next.add(id);
    return next;
  });

  const useMyLocation = () => {
    if (!navigator.geolocation) { setError('Tarayıcınız konum özelliğini desteklemiyor.'); return; }
    setLocating(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => { setStartCoords({ lat: pos.coords.latitude, lng: pos.coords.longitude }); setStartAddress('Mevcut konumum'); setLocating(false); },
      () => { setError('Konum alınamadı - lütfen tarayıcı izinlerini kontrol edin ya da adresi elle yazın.'); setLocating(false); },
      { timeout: 10000 }
    );
  };

  const submit = async () => {
    setError('');
    if (!startAddress.trim() && !startCoords) return setError('Başlangıç adresi girin ya da konumunuzu kullanın.');
    if (selectedIds.size === 0) return setError('En az bir durak seçin.');
    setPhase('loading');
    try {
      const body = { survey_ids: [...selectedIds], start_address: startAddress };
      if (startCoords) { body.start_lat = startCoords.lat; body.start_lng = startCoords.lng; }
      const { data } = await api('/surveys/route/optimize', { method: 'post', data: body });
      setResult(data);
      setReordered(false);
      setPhase('result');
    } catch (e) {
      setError(e.response?.data?.message || e.response?.data?.error || 'Rota hesaplanamadı');
      setPhase('select');
    }
  };

  const moveStop = (index, dir) => {
    if (!result) return;
    const stops = [...result.stops];
    const j = index + dir;
    if (j < 0 || j >= stops.length) return;
    [stops[index], stops[j]] = [stops[j], stops[index]];
    stops.forEach((s, i) => { s.order = i + 1; });
    const mapsUrls = buildMapsUrlsClient([{ lat: result.start.lat, lng: result.start.lng }, ...stops.map(s => ({ lat: s.lat, lng: s.lng }))]);
    setResult({ ...result, stops, google_maps_urls: mapsUrls, google_maps_url: mapsUrls[0]?.url || null });
    setReordered(true);
  };

  const copyLink = () => {
    if (result?.google_maps_url) navigator.clipboard?.writeText(result.google_maps_url).catch(() => {});
  };

  const dayLabel = new Date(date).toLocaleDateString('tr-TR', { day: '2-digit', month: 'long', year: 'numeric' });

  return (
    <div style={overlay} onClick={onClose}>
      <div style={{ ...mBox, width: '700px', maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 800, color: '#0f172a' }}>🗺️ Rota Çıkar</h2>
          <button onClick={onClose} style={xBtn}>×</button>
        </div>
        {error && <div style={errBox}>{error}</div>}

        {phase === 'select' && (
          <>
            <Sec title="📅 Tarih">
              <input type="date" style={{ ...inp, width: '200px' }} value={date} onChange={e => setDate(e.target.value)} />
              <div style={{ fontSize: '12px', color: '#94a3b8', marginTop: '6px' }}>{dayCandidates.length} randevu — {dayLabel}</div>
            </Sec>

            <Sec title="📍 Duraklar">
              {dayCandidates.length === 0 ? (
                <div style={{ fontSize: '13px', color: '#94a3b8', fontStyle: 'italic' }}>Bu tarihte planlanmış keşif yok.</div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', maxHeight: '260px', overflowY: 'auto' }}>
                  {dayCandidates.map(s => {
                    const hasAddress = !!(s.address && s.address.trim());
                    return (
                      <label key={s.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 10px', borderRadius: '8px', background: '#f8fafc', opacity: hasAddress ? 1 : 0.6, cursor: hasAddress ? 'pointer' : 'not-allowed' }}>
                        <input type="checkbox" disabled={!hasAddress} checked={selectedIds.has(s.id)} onChange={() => toggle(s.id)} />
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: '13px', fontWeight: 700, color: '#1e293b' }}>
                            {fmt(s.scheduled_at).split(' ').slice(-1)[0]} · {s.customer_first_name} {s.customer_last_name}
                          </div>
                          <div style={{ fontSize: '12px', color: '#64748b', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {hasAddress ? s.address : '⚠ Adres yok'}
                          </div>
                        </div>
                      </label>
                    );
                  })}
                </div>
              )}
            </Sec>

            <Sec title="🚩 Başlangıç Noktası">
              <div style={{ display: 'flex', gap: '8px' }}>
                <input style={inp} value={startAddress} onChange={e => { setStartAddress(e.target.value); setStartCoords(null); }}
                  placeholder="Şu an bulunduğunuz adres (ör. Moda Cad. 12, Kadıköy, İstanbul)" />
                <button onClick={useMyLocation} disabled={locating} style={{ ...btnSec, flexShrink: 0, whiteSpace: 'nowrap' }}>
                  {locating ? '...' : '📍 Konumumu Kullan'}
                </button>
              </div>
              <div style={{ fontSize: '11px', color: '#94a3b8', marginTop: '6px' }}>Sokak, ilçe ve şehir birlikte yazılırsa daha doğru sonuç alınır.</div>
            </Sec>

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
              <button onClick={onClose} style={btnSec}>İptal</button>
              <button onClick={submit} style={btnPri}>🚗 Rotayı Hesapla</button>
            </div>
          </>
        )}

        {phase === 'loading' && (
          <div style={{ textAlign: 'center', padding: '50px 0' }}>
            <div style={{ width: 40, height: 40, border: '3px solid #e0e7ff', borderTopColor: 'var(--tertiary)', borderRadius: '50%', animation: 'route-spin 1s linear infinite', margin: '0 auto 16px' }} />
            <style>{'@keyframes route-spin{to{transform:rotate(360deg)}}'}</style>
            <div style={{ fontWeight: 700, color: '#1e293b', marginBottom: '6px' }}>Adresler haritada aranıyor… (yaklaşık {selectedIds.size} saniye sürebilir)</div>
            <div style={{ fontSize: '12px', color: '#94a3b8' }}>Ücretsiz OpenStreetMap servisi kullanıldığı için adresler saniyede bir sorgulanıyor. Daha önce bulunmuş adresler anında gelir.</div>
          </div>
        )}

        {phase === 'result' && result && (
          <>
            <div style={{ display: 'flex', gap: '10px', marginBottom: '16px', flexWrap: 'wrap' }}>
              <div style={{ background: '#eef2ff', padding: '10px 14px', borderRadius: '10px' }}>
                <div style={{ fontSize: '11px', color: '#64748b' }}>Toplam Mesafe</div>
                <div style={{ fontSize: '16px', fontWeight: 800, color: 'var(--tertiary)' }}>{reordered ? '~' : ''}{result.total_km} km</div>
              </div>
              <div style={{ background: '#eef2ff', padding: '10px 14px', borderRadius: '10px' }}>
                <div style={{ fontSize: '11px', color: '#64748b' }}>Durak</div>
                <div style={{ fontSize: '16px', fontWeight: 800, color: 'var(--tertiary)' }}>{result.stops.length}</div>
              </div>
              {!reordered && result.total_km_original > result.total_km && (
                <div style={{ background: '#ecfdf5', padding: '10px 14px', borderRadius: '10px' }}>
                  <div style={{ fontSize: '11px', color: '#64748b' }}>Kazanç</div>
                  <div style={{ fontSize: '16px', fontWeight: 800, color: '#10b981' }}>%{Math.round((1 - result.total_km / result.total_km_original) * 100)}</div>
                </div>
              )}
            </div>

            <div style={{ background: '#f8fafc', padding: '10px 14px', borderRadius: '10px', marginBottom: '10px', fontSize: '13px', color: '#475569' }}>
              🚩 <strong>Başlangıç:</strong> {result.start.resolved_address}
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' }}>
              {result.stops.map((s, i) => (
                <div key={s.survey_id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 12px', background: 'white', border: '1px solid #f1f5f9', borderRadius: '10px' }}>
                  <div style={{ width: 26, height: 26, borderRadius: '50%', background: 'var(--tertiary)', color: 'white', fontWeight: 800, fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{s.order}</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: '13px', fontWeight: 700, color: '#1e293b' }}>
                      {s.customer_name} {s.precision === 'district' && <span style={{ fontSize: '10px', color: '#d97706', background: '#fffbeb', padding: '1px 6px', borderRadius: '8px', marginLeft: '4px' }}>≈ ilçe</span>}
                    </div>
                    <div style={{ fontSize: '12px', color: '#64748b', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{s.address}</div>
                  </div>
                  <div style={{ fontSize: '12px', fontWeight: 700, color: 'var(--tertiary)', flexShrink: 0 }}>+{s.leg_km} km</div>
                  <div style={{ display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
                    <button onClick={() => moveStop(i, -1)} disabled={i === 0} style={reorderBtn}>▲</button>
                    <button onClick={() => moveStop(i, 1)} disabled={i === result.stops.length - 1} style={reorderBtn}>▼</button>
                  </div>
                </div>
              ))}
            </div>

            {result.skipped.length > 0 && (
              <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: '10px', padding: '12px', marginBottom: '16px' }}>
                <div style={{ fontSize: '12px', fontWeight: 700, color: '#92400e', marginBottom: '6px' }}>⚠ Rotaya Eklenmeyenler ({result.skipped.length})</div>
                {result.skipped.map(sk => (
                  <div key={sk.survey_id} style={{ fontSize: '12px', color: '#78350f', marginBottom: '2px' }}>
                    {sk.customer_name || `Keşif #${sk.survey_id}`}{sk.address ? ` — ${sk.address}` : ''}: {sk.message}
                  </div>
                ))}
              </div>
            )}

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
              <button onClick={() => setPhase('select')} style={btnSec}>← Geri</button>
              <button onClick={copyLink} style={btnSec}>📋 Linki Kopyala</button>
              {result.google_maps_urls.map((m, i) => (
                <button key={i} onClick={() => window.open(m.url, '_blank', 'noopener')} style={btnPri}>
                  🗺️ {result.google_maps_urls.length > 1 ? m.label : 'Google Maps\'te Aç'}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
const reorderBtn = { border: 'none', background: 'none', cursor: 'pointer', color: '#94a3b8', fontSize: '11px', padding: '1px 4px', lineHeight: 1.4 };

// ─── Survey Card ──────────────────────────────────────────────────────────────
function SurveyCard({ s, onClick }) {
  const st = STATUS_MAP[s.status] || STATUS_MAP.pending;
  const isToday = s.scheduled_at && new Date(s.scheduled_at).toDateString() === new Date().toDateString();
  return (
    <div onClick={onClick}
      style={{ background: 'white', borderRadius: '14px', padding: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', cursor: 'pointer', border: `1px solid ${isToday ? '#818cf8' : '#f1f5f9'}`, transition: 'all .15s', position: 'relative' }}
      onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.12)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
      onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.07)'; e.currentTarget.style.transform = 'none'; }}>
      {isToday && <span style={{ position: 'absolute', top: '12px', right: '12px', fontSize: '10px', fontWeight: 700, background: 'var(--tertiary)', color: 'white', padding: '2px 8px', borderRadius: '10px' }}>BUGÜN</span>}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' }}>
        <span style={{ fontSize: '11px', fontWeight: 700, color: st.color, background: st.bg, padding: '3px 10px', borderRadius: '20px' }}>{st.label}</span>
      </div>
      <div style={{ fontWeight: 800, fontSize: '15px', color: '#0f172a', marginBottom: '4px' }}>
        {s.customer_first_name} {s.customer_last_name}
      </div>
      {s.customer_phone && <div style={{ fontSize: '12px', color: '#94a3b8', marginBottom: '2px' }}>📞 {s.customer_phone}</div>}
      <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '8px' }}>
        {[s.city, s.district].filter(Boolean).join(' / ') || '-'}
      </div>
      <div style={{ fontSize: '12px', fontWeight: 600, color: '#475569' }}>📅 {fmt(s.scheduled_at)}</div>
      {s.notes && <div style={{ fontSize: '11px', color: '#94a3b8', marginTop: '6px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>📝 {s.notes}</div>}
    </div>
  );
}

// ─── Main ─────────────────────────────────────────────────────────────────────
export default function Surveys() {
  const [surveys, setSurveys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNew, setShowNew] = useState(false);
  const [showRoute, setShowRoute] = useState(false);
  const [selected, setSelected] = useState(null);
  const [filterStatus, setFilterStatus] = useState('all');
  const [search, setSearch] = useState('');

  const fetchSurveys = useCallback(async () => {
    try { setSurveys((await api('/surveys')).data); }
    catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchSurveys(); }, [fetchSurveys]);

  const handleUpdated = (id, fields) =>
    setSurveys(prev => prev.map(s => s.id === id ? { ...s, ...fields } : s));

  const handleDeleted = id => setSurveys(prev => prev.filter(s => s.id !== id));

  const filtered = surveys.filter(s => {
    const ok = filterStatus === 'all' || s.status === filterStatus;
    const q = search.toLowerCase();
    const match = !q || [s.customer_first_name, s.customer_last_name, s.customer_phone, s.city, s.district].some(v => v?.toLowerCase().includes(q));
    return ok && match;
  });

  const todayCount = surveys.filter(s => s.scheduled_at && new Date(s.scheduled_at).toDateString() === new Date().toDateString()).length;

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', gap: '12px', color: 'var(--tertiary)', flexDirection: 'column' }}>
      <div style={{ width: 40, height: 40, border: '3px solid #e0e7ff', borderTopColor: 'var(--tertiary)', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
      <span style={{ fontWeight: 600 }}>Yükleniyor...</span>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#f8fafc' }}>

      {/* Header */}
      <div style={{ background: 'white', borderBottom: '1px solid #f1f5f9', padding: '18px 24px 14px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', gap: '12px' }}>
          <div>
            <h1 style={{ margin: 0, fontSize: '22px', fontWeight: 800, color: '#0f172a' }}>🔍 Keşif Randevuları</h1>
            <p style={{ margin: '2px 0 0', fontSize: '13px', color: '#94a3b8' }}>Duşakabin ölçü ve keşif randevularını yönetin</p>
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button onClick={fetchSurveys} style={btnSec}>🔄 Yenile</button>
            <button onClick={() => setShowRoute(true)} style={btnSec}>🗺️ Rota Çıkar</button>
            <button onClick={() => setShowNew(true)} style={btnPri}>+ Yeni Keşif</button>
          </div>
        </div>

        {/* Stats */}
        <div style={{ display: 'flex', gap: '10px', marginBottom: '14px', overflowX: 'auto' }}>
          {[
            { l: 'Toplam', v: surveys.length, c: '#6366f1', b: '#eef2ff', i: '📋' },
            { l: 'Bugün', v: todayCount, c: '#ec4899', b: '#fdf2f8', i: '🗓️' },
            ...Object.entries(STATUS_MAP).map(([k, v]) => ({ l: v.label, v: surveys.filter(s => s.status === k).length, c: v.color, b: v.bg, i: '' })),
          ].map(st => (
            <div key={st.l} style={{ minWidth: '100px', background: st.b, padding: '10px 14px', borderRadius: '10px', flexShrink: 0 }}>
              <div style={{ fontSize: '14px' }}>{st.i}</div>
              <div style={{ fontSize: '18px', fontWeight: 800, color: st.c }}>{st.v}</div>
              <div style={{ fontSize: '11px', color: '#64748b', fontWeight: 500 }}>{st.l}</div>
            </div>
          ))}
        </div>

        {/* Filters */}
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="🔍 Müşteri, telefon, şehir..."
            style={{ ...inp, width: '220px', padding: '8px 12px', fontSize: '13px' }} />
          <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
            <FilterBtn active={filterStatus === 'all'} color="#1e293b" onClick={() => setFilterStatus('all')}>Tümü ({surveys.length})</FilterBtn>
            {Object.entries(STATUS_MAP).map(([k, v]) => (
              <FilterBtn key={k} active={filterStatus === k} color={v.color} onClick={() => setFilterStatus(k)}>
                {v.label} ({surveys.filter(s => s.status === k).length})
              </FilterBtn>
            ))}
          </div>
        </div>
      </div>

      {/* Grid */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '20px 24px' }}>
        {filtered.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '80px 0', color: '#94a3b8' }}>
            <div style={{ fontSize: '52px', marginBottom: '12px' }}>🔍</div>
            <div style={{ fontSize: '18px', fontWeight: 700, color: '#64748b', marginBottom: '8px' }}>
              {surveys.length === 0 ? 'Henüz keşif randevusu yok' : 'Sonuç bulunamadı'}
            </div>
            {surveys.length === 0 && <div style={{ fontSize: '14px' }}>"Yeni Keşif" butonuyla başlayın.</div>}
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(270px, 1fr))', gap: '14px' }}>
            {filtered.map(s => (
              <SurveyCard key={s.id} s={s} onClick={() => setSelected(s)} />
            ))}
          </div>
        )}
      </div>

      {showNew && <NewSurveyModal onClose={() => setShowNew(false)} onCreated={fetchSurveys} />}
      {showRoute && <RouteModal surveys={surveys} onClose={() => setShowRoute(false)} />}
      {selected && (
        <DetailModal
          survey={{ ...selected, ...surveys.find(s => s.id === selected.id) }}
          onClose={() => setSelected(null)}
          onUpdated={handleUpdated}
          onDeleted={handleDeleted}
        />
      )}
    </div>
  );
}

// ─── Sub-components ───────────────────────────────────────────────────────────
function Sec({ title, children }) {
  return (
    <div style={{ marginBottom: '20px' }}>
      <div style={{ fontSize: '11px', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: '12px' }}>{title}</div>
      {children}
    </div>
  );
}
function F({ l, children }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      <label style={{ fontSize: '12px', fontWeight: 600, color: '#64748b' }}>{l}</label>
      {children}
    </div>
  );
}
function FilterBtn({ active, color, onClick, children }) {
  return (
    <button onClick={onClick} style={{ padding: '6px 12px', borderRadius: '20px', border: `2px solid ${active ? color : '#e2e8f0'}`, background: active ? color : 'white', color: active ? 'white' : '#64748b', fontWeight: 600, fontSize: '11px', cursor: 'pointer', whiteSpace: 'nowrap' }}>
      {children}
    </button>
  );
}

// ─── Shared styles ────────────────────────────────────────────────────────────
const overlay = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: '20px' };
const mBox    = { background: 'white', borderRadius: '20px', padding: '28px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' };
const xBtn    = { background: 'none', border: 'none', fontSize: '26px', cursor: 'pointer', color: '#64748b', lineHeight: 1 };
const inp     = { border: '1px solid #e2e8f0', borderRadius: '8px', padding: '10px 12px', fontSize: '14px', fontFamily: 'inherit', outline: 'none', width: '100%', boxSizing: 'border-box', color: '#1e293b' };
const g2      = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' };
const btnPri  = { padding: '10px 22px', background: '#6366f1', color: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: 700, fontSize: '14px' };
const btnSec  = { padding: '10px 22px', background: 'white', color: '#64748b', border: '1px solid #e2e8f0', borderRadius: '10px', cursor: 'pointer', fontWeight: 600, fontSize: '14px' };
const errBox  = { background: '#fff5f5', border: '1px solid #fecaca', color: '#dc2626', padding: '12px 16px', borderRadius: '10px', fontSize: '13px', marginBottom: '16px' };
